<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  value: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['input'])

const pricingStatusOptions = [
  { text: 'Active pricing only', value: 'active' },
  { text: 'All pricing', value: '' }
]
</script>

<template>
  <v-select
    :value="value"
    :items="pricingStatusOptions"
    label="Pricing status"
    :menu-props="{
      bottom: true,
      offsetY: true,
      contentClass: 'mt-1'
    }"
    dense
    outlined
    hide-details
    @input="emit('input', $event)"
  />
</template>
